import { render, staticRenderFns } from "./TkAlterPay.vue?vue&type=template&id=68a199cc&scoped=true&"
import script from "./TkAlterPay.vue?vue&type=script&lang=js&"
export * from "./TkAlterPay.vue?vue&type=script&lang=js&"
import style0 from "./TkAlterPay.vue?vue&type=style&index=0&id=68a199cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a199cc",
  null
  
)

export default component.exports